import{createContext}from"react";var TextAncestorContext=createContext(!1);export default TextAncestorContext;